export default {
  components: {},
  props: {
    score: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    star1_width() {
      const score = this.score;
      return score > 0.7 ? ' star100' : ' star50';
    },
    star2_width() {
      const score = this.score;
      if (1.3 < score && score <= 1.7) {
        return ' star50';
      } else if (score > 1.7) {
        return ' star100';
      }
      return '';
    },
    star3_width() {
      const score = this.score;
      if (2.3 < score && score <= 2.7) {
        return ' star50';
      } else if (score > 2.7) {
        return ' star100';
      }
      return '';
    },
    star4_width() {
      const score = this.score;
      if (3.3 < score && score <= 3.7) {
        return ' star50';
      } else if (score > 3.7) {
        return ' star100';
      }
      return '';
    },
    star5_width() {
      const score = this.score;
      if (4.3 < score && score <= 4.7) {
        return ' star50';
      } else if (score > 4.7) {
        return ' star100';
      }
      return '';
    }
  },
  methods: {}
};